import React from 'react'
import SidebarContainer from '../../../containers/SidebarContainer'
import { WrapperPageMainWrapper, WrapperPagePanelWrapper, WrapperPageHeaderWrapper, WrapperPageTitle, WrapperPageCloseButton, WrapperPageContentWrapper, WrapperPageTitleWrapper } from './PageElements'


const WrapperPageSimple = ({
        pageTitle='',
        pageTitleTransId='',
        children,
        overlay = '',
        editPageButton='',
        addClassName='',
        closePagePath = false,
        handleScroll = false,
        id= false
    }) => {

    if(document.body && document.body.classList) {
        const elementorClasses = _.filter(document.body.classList, classItem => {
            if(classItem.search("elementor") !== -1) {
            return classItem
            }
        })
    
        elementorClasses.map(elementorClass => {
            document.body.classList.remove(elementorClass)
        })
        document.body.classList.remove('elementor-page')
    }

    return (
        <WrapperPageMainWrapper addClassName={addClassName}>
            <SidebarContainer />
            {overlay}
            <WrapperPagePanelWrapper handleScroll={handleScroll}>
                <WrapperPageHeaderWrapper>
                    <WrapperPageTitleWrapper>
                        {editPageButton}
                        <WrapperPageTitle pageTitle={pageTitle} pageTitleTransId={pageTitleTransId} id={id}/>
                    </WrapperPageTitleWrapper>
                    <WrapperPageCloseButton closePagePath={closePagePath} />
                </WrapperPageHeaderWrapper>

                <WrapperPageContentWrapper>
                    {children}
                </WrapperPageContentWrapper>
            </WrapperPagePanelWrapper>
        </WrapperPageMainWrapper>
    )
}

export default WrapperPageSimple